// extracted by mini-css-extract-plugin
export var backButton = "_r-1";
export var content = "_r-d";
export var continueButton = "_r-7";
export var continueHint = "_r-8";
export var continueRow = "_r-6";
export var leftInner = "_r-0";
export var shell = "_r-e";
export var sidebarContent = "_r-5";
export var skipButton = "_r-c";
export var spacer = "_r-2";
export var spin = "_r-a";
export var spinner = "_r-9";
export var spinnerOverlay = "_r-b";
export var subtitle = "_r-4";
export var title = "_r-3";